import { InputField, InputSelectOptions } from 'components'
import LoaderButton from 'components/molecules/loader-button'
import { COURIER_SERVICE_TYPE, COURIER } from 'domains/customer-refund-shipment/constants'
import customerRefundShipmentCreateSchema from './customer-refund-shipment-create-schema'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  onSubmit: PropTypes.func.isRequired
}

/**
 * Form to create new Customer Refund Shipment
 * @param {func} onSubmit Handler for submitting the form
 */
const CustomerRefundShipmentCreateForm = ({
  onSubmit
}) => (
  <Formik
    enableReinitialize={ false }
    initialValues={{
      courier              : '',
      courier_service_type : ''
    }}
    validationSchema={ customerRefundShipmentCreateSchema }
    onSubmit={ onSubmit }
  >
    {
      (formikBag) => (
        <Form>

          <InputField
            type='select'
            name='courier'
            label='Courier'
            required={ true }
          >
            <InputSelectOptions options={ COURIER } keyPrefix={ 'courier' } />
          </InputField>

          <InputField
            type='select'
            name='courier_service_type'
            label='Courier Service Type'
            required={ true }
          >
            <InputSelectOptions options={ COURIER_SERVICE_TYPE } keyPrefix={ 'courier-service-type' } />
          </InputField>

          <LoaderButton
            color='primary'
            type='submit'
            onSubmit={ formikBag.submitForm }
            disabled={ formikBag.isSubmitting }
            isLoading={ formikBag.isSubmitting }
            text='Create Shipment'
          />

        </Form>
      )
    }
  </Formik>
)

CustomerRefundShipmentCreateForm.propTypes = propTypes

export default CustomerRefundShipmentCreateForm
